import { render, staticRenderFns } from "./CustomDragDialog.vue?vue&type=template&id=15ce5243&scoped=true"
import script from "./CustomDragDialog.vue?vue&type=script&lang=js"
export * from "./CustomDragDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomDragDialog.vue?vue&type=style&index=0&id=15ce5243&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce5243",
  null
  
)

export default component.exports